import type { NodeDto, NodeRelationshipDto } from "@mmm/contracts";
import { IconButton } from "../ui/IconButton.js";
import { useT } from "@mmm/ui";
export type DisplayRelationship = NodeRelationshipDto & { pending?: boolean };

function centerOf(node: NodeDto) {
  return { x: node.x + node.width / 2, y: node.y + node.height / 2 };
}

interface RelationshipEdgeSvgProps {
  nodesById: Map<string, NodeDto>;
  relationships: DisplayRelationship[];
  onDeleteRelationship: (relationship: NodeRelationshipDto) => void;
  controlsOnly?: boolean;
}

export function RelationshipEdgeSvg({ nodesById, relationships, onDeleteRelationship, controlsOnly = false }: RelationshipEdgeSvgProps) {
  const t = useT();
  return (
    <svg className={`mmm-map-edges ${controlsOnly ? "mmm-map-edge-controls" : ""}`.trim()} aria-label={controlsOnly ? t("maps.nodeConnections") : undefined} aria-hidden={controlsOnly ? undefined : true}>
      {relationships.map((relationship) => {
        const from = nodesById.get(relationship.fromNodeId);
        const to = nodesById.get(relationship.toNodeId);
        if (!from || !to) return null;

        const start = centerOf(from);
        const end = centerOf(to);
        const midX = (start.x + end.x) / 2;
        const midY = (start.y + end.y) / 2;
        const path = `M ${start.x} ${start.y} C ${midX} ${start.y}, ${midX} ${end.y}, ${end.x} ${end.y}`;

        return (
          <g
            key={relationship.id}
            className="mmm-map-edge"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
          >
            {!controlsOnly && <path className="mmm-map-edge-hit" d={path} />}
            {!controlsOnly && <path
              className={`mmm-map-edge-line ${relationship.pending ? "mmm-map-edge-line--pending" : ""}`.trim()}
              d={path}
              stroke={relationship.stroke || "#c4bedd"}
            />}
            {controlsOnly && !relationship.pending && (
              <foreignObject className="mmm-map-edge-delete" x={midX - 15} y={midY - 15} width={30} height={30}>
                <IconButton
                  icon="trash"
                  label={t("maps.deleteConnectionFromTo", { from: from.title, to: to.title })}
                  className="mmm-map-edge-delete-btn mmm-row-action-btn mmm-row-action-btn--danger"
                  onClick={(event) => {
                    event.stopPropagation();
                    onDeleteRelationship(relationship);
                  }}
                />
              </foreignObject>
            )}
          </g>
        );
      })}
    </svg>
  );
}
